<style lang="scss" scoped>
  @import '../../../sass/utilities/variables';

  .page-container {
    width: 80rem;
    margin: 5rem auto;
  }

  .header-container {
    padding-bottom: 3rem;
    border-bottom: 1px solid $light-silver;
  }

  .title-text {
    font-weight: 300;
    font-style: normal;
    font-size: 3rem;
    color: $dark-grey;
  }

  .description-text {
    margin-top: 1.5rem;
    font-weight: 400;
    font-style: normal;
    font-size: 1.4rem;
    color: $dark-grey;
  }
</style>
<template>
  <div
    class="page-container"
    v-if="pageLoaded"
  >
    <div class="header-container">
      <div class="title-text">
        {{ titleText }}
      </div>
      <div class="description-text">
        {{ descriptionText }}
      </div>
    </div>
    <div
      v-for="employer in this.employers" :key="employer.id"
    >
      <employer-card
        :data="employer"
      >
      </employer-card>
    </div>
  </div>
</template>
<script>
import ApiRequest from '../../../js/api-request';
import EmployerCard from './employer-card.vue';

export default {
  created() {
    this.getEmployers();
  },

  data() {
    return {
      employers: [],
      pageLoaded: false,
    };
  },

  computed: {
    dummyEmployerData() {
      return [
        {
          employerName: 'Test Employer 1',
          jobsAvailable: 24,
        },
        {
          employerName: 'Test Employer 2',
          jobsAvailable: 3,
        },
        {
          employerName: 'Test Employer 3',
          jobsAvailable: 178,
        },
        {
          employerName: 'Test Employer 4',
          jobsAvailable: 22,
        },
        {
          employerName: 'Test Employer 5',
          jobsAvailable: 62,
        },
        {
          employerName: 'Test Employer 6',
          jobsAvailable: 8,
        },
      ];
    },

    titleText() {
      return 'Employer Career Pages Directory';
    },

    descriptionText() {
      return 'A comprehensive list of employers with active career pages.';
    },
  },

  methods: {
    getEmployers() {
      new ApiRequest('/api/careers-page/employers',
        (data) => {
          this.employers = data;
          this.pageLoaded = true;
        },
        (error) => {
          console.error(error);
        }).get();
    },
  },

  components: {
    EmployerCard,
  },
};
</script>
